export const getCategories = {
  category: "category/allcategoriesWEB",
};
